export const videoLayouts = ["grid-1", "grid-2", "grid-4", "grid-5", "grid-6", "grid-9", "grid-10", "grid-16", "grid-20"] as const;
export type VideoLayout = (typeof videoLayouts)[number];

export const videoLayoutCapacity: Record<VideoLayout, number> = {
  "grid-1": 1,
  "grid-2": 2,
  "grid-4": 4,
  "grid-5": 5,
  "grid-6": 6,
  "grid-9": 9,
  "grid-10": 10,
  "grid-16": 16,
  "grid-20": 20
};

export function normalizeCameraLayout(availableIds: string[], saved: Array<string | null>, layout: VideoLayout): Array<string | null> {
  const capacity = videoLayoutCapacity[layout];
  const available = new Set(availableIds);
  const source = saved.length ? saved : availableIds.slice(0, capacity);
  const used = new Set<string>();
  return Array.from({ length: capacity }, (_, index) => {
    const id = source[index];
    if (!id || !available.has(id) || used.has(id)) return null;
    used.add(id);
    return id;
  });
}

export function layoutItems<T extends { id: string }>(items: T[], saved: Array<string | null>, layout: VideoLayout): Array<T | null> {
  const byId = new Map(items.map((item) => [item.id, item]));
  return normalizeCameraLayout(items.map((item) => item.id), saved, layout).map((id) => id ? byId.get(id) ?? null : null);
}
